import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import Store from '../../Store';
import { OnChangeDPI, OnChangeQuality, OnIncreaseQuality, OnDecreaseQuality } from '../../Document/_actions/DocumentActions';
import { OnCenterDocument } from '../../Tools/_actions/ToolsActions';
import HIDContainer from '../../HID/_containers/HIDContainer';
import WorkCanvas, { Props } from '../_components/WorkCanvas';

const mapStateToProps = (store:Store, props:Props) => ({
	documentQuality: store.getIn(['create', 'document', 'quality']),
	documentDPI: store.getIn(['create', 'document', 'dpi']),
});

const mapDispatchToProps = (dispatch:Dispatch, props:Props) => ({
	setDPI: (dpi:number) => dispatch(OnChangeDPI(dpi)),
	setQuality: (quality:number) => dispatch(OnChangeQuality(quality)),
	centerDocument: () => dispatch(OnCenterDocument()),
	increaseQuality: (maxQuality: number) => dispatch(OnIncreaseQuality(maxQuality)),
	decreaseQuality: () => dispatch(OnDecreaseQuality()),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(WorkCanvas);